import React, { Component } from "react";
import { Graphics } from './contents/Graphics';

import './GelBox.scss'

export class GelBox extends Component {

  componentWillMount() {
    this.props.createGelBox({
      props: this.props.defaultProps,
    });
  }

  toggleToolTipControls = (showControls) => {
    this.props.toggleToolTipControls({
      id: this.props.id,
      showTooltipControls: showControls
    })
  }
    render() {
        return (
          <ul>
            <li
              aria-label="Gel electrophoresis Box"
              id={'GelBox_'+this.props.id}
              className={'GelBox'+((this.props.open)?' open':'')+' dropTarget'}>
              <p aria-hidden="true" className="label" style={{display:"none"}}>{this.props.type}</p>
              <div
                onMouseEnter={()=>this.toggleToolTipControls(true)}
                onMouseLeave={()=>this.toggleToolTipControls(false)}
              >
                <div className="electrodes">
                  <div className="electrode">
                    <div id={'GelBox_'+this.props.id+'_NegativeElectrode'} className="dropTarget">
                      <p aria-hidden="true" className="label" style={{display:"none"}}>Gel Electrophoresis Box Anode</p>
                    </div>
                  </div>
                  <div className="electrode">
                    <div id={'GelBox_'+this.props.id+'_PositiveElectrode'} className="dropTarget">
                      <p aria-hidden="true" className="label" style={{display:"none"}}>Gel Electrophoresis Box Cathode</p>
                    </div>
                  </div>
                </div>
                  <Graphics id={this.props.id}/>
              </div>
            </li>
          </ul>
        );
    }
}